import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

window.assets = window.assets || {};

assets.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
}

assets.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = assets && assets.settings && assets.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = assets.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = assets.utils.defaultTo(precision, 2);
        thousands = assets.utils.defaultTo(thousands, ',');
        decimal = assets.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
})();

const cartDrawer = document.querySelector("cart-drawer-component");
window.getRecommendations = function(productId) {
  const url = `/recommendations/products?product_id=${productId}&sections=cart-upsell&limit=2&intent=related`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      const container = document.querySelector("[js-cart-upsell-grid]");
      if (!container) return;

      container.innerHTML = data["cart-upsell"];
    })
    .catch(err => console.error("Section Rendering Error:", err));
}


if(cartDrawer.getAttribute("data-first-line-item-product-id")) {
  getRecommendations(cartDrawer.getAttribute("data-first-line-item-product-id"));
}

cartDrawer.addEventListener("click", async function({ target }) {
  if(target.tagName === "UPSELL-ATC-BTN") {
    const upsellItem = target.closest("[js-upsell-item]");
    const variantId = upsellItem.querySelector("[js-upsell-variant-id]").value;

    target.disabled = true;
    target.textContent = "Adding...";

    localStorage.setItem("productId", target.getAttribute('data-product-id'));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      const data = await res.json();

      this.dispatchEvent(
        new CartAddEvent({}, this.id, {
          didError: true,
          source: 'product-form-component',
          itemCount: 1,
          productId: "345678967856",
        })
      );

    } catch (error) {
    }

  }
})

class SizeGuidePopup extends HTMLElement {
    constructor() {
      super();

      this.openBtn  = this.querySelector(".size-guide-trigger-btn");
      this.popup    = document.querySelector("[js-size-guide-popup]");
      this.closeBtn = this.popup.querySelector("[js-close-size-guide]");
      this.sizeGuideImg = this.popup.querySelector("[js-size-guide-img]");
    }

    connectedCallback() {
      this.openBtn.addEventListener("click", ({currentTarget}) => {

        this.sizeGuideImg.setAttribute('src', currentTarget.getAttribute('data-img-src'));
        this.popup.showModal();
      });

      this.closeBtn.addEventListener("click", () => {
        this.closePopup();
      });

      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });
    }

    closePopup() {
      this.sizeGuideImg.setAttribute('src', '');
      this.popup.close();
    }
}

customElements.define("size-guide-popup", SizeGuidePopup);

document.addEventListener('rebuy:cart.add', (event) => { 
  setTimeout(function() {
    window?.Rebuy?.reinit()
  }, 500)
});
document.addEventListener('rebuy:cart.change', (event) => { 
  setTimeout(function() {
    window?.Rebuy?.reinit()
  }, 500)
});

document.addEventListener("click", function ({ target }) {
  if(target.hasAttribute("js-checkout-btn")) {
    window.location.href = "/checkout";
  };

  if(target.hasAttribute("js-shop-btn")) {
    const href = target.getAttribute("data-href");
    window.location.href = href;
  }

  if(target.classList.contains("resource-card__link") && target.closest("predictive-search-component")) {
    const href = target.getAttribute("href");
    window.location.href = href;
  }
});
